import { Component, OnInit } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { Store, Store_Sale_Report, User } from 'src/app/models/RestModels';
import { SearchObject } from 'src/app/services/Rest';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { BaseComponent } from '../base/base.component';

interface CustomStoreSaleReport extends Store_Sale_Report
{
	store:Store;
	user:User;
}

@Component({
	selector: 'app-list-sales-report',
	templateUrl: './list-sales-report.component.html',
	styleUrls: ['./list-sales-report.component.css']
})
export class ListSalesReportComponent extends BaseComponent implements OnInit
{
	sales_store_report_list: CustomStoreSaleReport[] = [];
	store_list:Store [] = [];
	sales_store_report_search:SearchObject<CustomStoreSaleReport> = this.getEmptySearch();

	path = '/list-sales-report';
    user_list: User[];

	ngOnInit(): void
	{
		this.subs.sink = this.getQueryParamObservable().pipe
		(
			mergeMap((response)=>
			{
				if( response[0].has('h'))
				{
					this.rest.has_ares = true;
				}

				let fields = ['store_id','date'];
				let search	= this.getSearch(response[0],fields,[]);
				this.sales_store_report_search = this.getSearch(response[0],fields,[]);

				search.sort_order = ['id_DESC'];

				return forkJoin
				({
					ssr: this.rest.store_sale_report.search( search ),
					store: this.rest.getStores()
				})
			}),
			mergeMap((response)=>
			{
				let user_ids = response.ssr.data.map(ssr=>ssr.created_by_user_id);
				return forkJoin({
					ssr: of(response.ssr),
					user: this.rest.user.search({csv:{id:user_ids},limit:99999}),
					store: of(response.store),
				})
			})
		)
		.subscribe((response)=>
		{
			this.store_list = response.store.data;
			this.setPages(this.sales_store_report_search.page,response.ssr.total);
			this.user_list = response.user.data;

			this.sales_store_report_list = response.ssr.data.map
			(
				ssr=>
				{
					let store =	this.store_list.find(s=>ssr.store_id == s.id ) || GetEmpty.store();
					let user = this.user_list.find(u=>ssr.created_by_user_id == u.id) || GetEmpty.user();
					return { ...ssr, store, user };
				}
			);
		});
	}

	showPaymentAbonos(ssr:Store_Sale_Report)
	{
		this.router.navigate(['/payment',ssr.id]);
	}

	showOrderAbonos(ssr:Store_Sale_Report)
	{
		this.router.navigate(['/order-abonos',ssr.id]);
	}

	delete(store_sale_report:Store_Sale_Report)
	{
		this.sink = this.confirmation.showConfirmAlert(store_sale_report, 'Confirmación', '¿Está seguro de querer eliminar este reporte de venta?')
		.pipe
		(
			filter((response)=>response.accepted),
			mergeMap((_response)=>
			{
				return this.rest.store_sale_report.delete({id:store_sale_report.id});
			})
		)
		.subscribe
		({
			next: ()=>
			{
				this.sales_store_report_list = this.sales_store_report_list.filter(ssr => ssr.id != store_sale_report.id);
				this.showSuccess('Reporte de venta eliminado correctamente');
			},
			error: (error)=>{
				this.showError(error);
			}
		});
	}
}
